const DemoComponent = ({ message = 'Development Pending', feature = '' }) => {
    const styles = {
        container: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '400px',
            backgroundColor: 'var(--gradient-overlay-bg-color)',
            borderRadius: '12px',
            textAlign: 'center',
            width: '100%'
        },
        icon: {
            fontSize: '64px',
            marginBottom: '20px',
            animation: 'pulse 2s ease-in-out infinite',
        },
        title: {
            fontSize: '28px',
            fontWeight: '700',
            color: '#f5f5f5',
            marginBottom: '12px',
            fontFamily: 'Nunito, sans-serif',
        },
        subtitle: {
            fontSize: '18px',
            color: '#f8a21e',
            marginBottom: '8px',
            fontWeight: '600',
            fontFamily: 'Nunito Sans, sans-serif',
        },
        description: {
            fontSize: '14px',
            color: '#f5f5f5',
            maxWidth: '500px',
            lineHeight: '1.6',
            fontFamily: 'Noto Sans, sans-serif',
        }
    };

    const keyframes = `
        @keyframes pulse {
            0%, 100% {
                transform: scale(1);
                opacity: 1;
            }
            50% {
                transform: scale(1.1);
                opacity: 0.8;
            }
        }
    `;

    return (
        <>
            <style>{keyframes}</style>
            <div style={styles.container}>
                <div style={styles.icon}>🚧</div>
                <h2 style={styles.title}>{message}</h2>
                {feature && <p style={styles.subtitle}>Feature: {feature}</p>}
                <p style={styles.description}>
                    This component is a placeholder for functionality that is currently pending development.
                </p>
            </div>
        </>
    );
};

export default DemoComponent;